import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const Kiplinger: Site = {
  id: 'kiplinger',
  logo: 'svg/kiplinger.svg',
  label: 'Kiplinger',
  analyticsName: 'Kiplinger',
  hostname: 'kiplinger.com',
  platform: 'progressive',
  selector: `${progressiveVanillaSelector}, .polaris__app a`,
};
